import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
const FileUpload = ({ onUploadSuccess }) => {
  const [file, setFile] = useState(null);
  const [file2, setFile2] = useState(null);
  const [reload, setReload] = useState(false);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null);
  const [statusCC, setStatusCC] = useState(null);
  const [statusTF, setStatusTF] = useState(null);
  const [errorCodeCC, setErrorCodeCC] = useState(null);
  const [triggerCCApi, setTriggerCCApi] = useState(false);
  const [triggerSecondApi, setTriggerSecondApi] = useState(false);
  const [finalUpload, setFinalUpload] = useState(false);
  const [compantNameEng, setCompantNameEng] = useState(null);
  const [compantNameChi, setCompantNameChi] = useState(null);
  const [registeredAddress, setRegisteredAddress] = useState(null);
  const [placeofincorporation, setPlaceofincorporation] = useState(null);
  const [contactname, setContactname] = useState(null);
  const [contactemailaddress, setContactemailaddress] = useState(null);
  const [bankAccountNumber, setBankAccountNumber] = useState(null);
  const [bankName, setBankName] = useState(null);
  const [bankCode, setBankCode] = useState(null);
  const [swift, setSwift] = useState(null);
  const [beneficiaryName, setBeneficiaryName] = useState(null);

  const [contactphonenumber, setContactphonenumber] = useState(null);
  const [businessRegistrationNumber, setBusinessRegistrationNumber] =
    useState(null);

  //   TF
  const [subcontractNo, setSubcontractNo] = useState(null);
  const [subcontractno, setSubcontractno] = useState(null);
  const [errorCodeTF, setErrorCodeTF] = useState(null);
  const [contractType, setContractType] = useState(null);
  const [contractName, setContractName] = useState(null);
  const [contractDetails, setContractDetails] = useState(null);
  const [projectName, setProjectName] = useState(null);
  const [projectDetails, setProjectDetails] = useState(null);
  const [documentCertifyingNo, setDocumentCertifyingNo] = useState(null);
  const [documentCertifyingIssuedby, setDocumentCertifyingIssuedby] =
    useState(null);
  const [nameofDebtor, setNameofDebtor] = useState(null);
  const [riverchainIDNo, setRiverchainIDNo] = useState(null);
  const [nameofPurchaser, setNameofPurchaser] = useState(null);
  const [invoiceNo, setInvoiceNo] = useState(null);
  const [nameofPurchaserIfother, setNameofPurchaserIfother] = useState(null);
  const [documentCertifyingAmountHK, setDocumentCertifyingAmountHK] =
    useState(null);
  const [documentCertifyingDate, setDocumentCertifyingDate] = useState(null);
  const [invoiceAmountHK, setInvoiceAmountHK] = useState(null);
  const [invoiceDate, setInvoiceDate] = useState(null);
  const [discount_percentage_, setDiscount_percentage_] = useState(null);
  const [repaymentPercentage, setRepaymentPercentage] = useState(null);
  const [prepaymentAmount, setPrepaymentAmount] = useState(null);
  const [documentOriginatingtheDebt, setDocumentOriginatingtheDebt] =
    useState(null);
  const [
    documentCertifyingthePaymentValuation,
    setDocumentCertifyingthePaymentValuation,
  ] = useState(null);

  const [seller, setSeller] = useState(null);
  const [rebateAmount, setRebateAmount] = useState(null);
  const fileInputRef = useRef(null);
  const fileInputRef2 = useRef(null);

  // const BACKEND_URL = "http://localhost:8000";
  // const API_URL = "http://localhost:5001/api";
  const BACKEND_URL = "https://atlas.docauto.riverchain.xyz";
  const API_URL = "https://atlas.docauto.riverchain.xyz/api";

  function formatDate(dateStr) {
    if (!dateStr) {
      return "Invalid date"; // Handle null, undefined, or empty string
    }

    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const parts = dateStr.split("-");
    if (parts.length !== 3) {
      return "Invalid date format"; // Handle incorrect format
    }

    const [year, month, day] = parts;
    if (isNaN(year) || isNaN(month) || isNaN(day)) {
      return "Invalid date values"; // Ensure all parts are numbers
    }

    return `${parseInt(day)} ${months[parseInt(month) - 1]} ${year}`;
  }

  function formatNumber(value) {
    if (!value || isNaN(value)) return "Invalid Number";

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  }

  const handleUploadCC = async () => {
    try {
      if (!file) {
        console.error("First file is missing!");
        setStatus("Please select the first file.");
        return false;
      }

      const formData1 = new FormData();
      formData1.append("file", file);

      console.log("Uploading first file...");
      const response = await fetch(`${BACKEND_URL}/uploadfile/`, {
        method: "POST",
        body: formData1,
        headers: { Accept: "application/json" },
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Server error: ${response.status} - ${errorText}`);
      }
      const data = await response.json();
      console.log("First file uploaded successfully:", data);

      setBankAccountNumber(
        data.content?.BankAccountNumber != null
          ? data.content?.BankAccountNumber
          : ""
      );
      setBankName(data.content?.BankName != null ? data.content?.BankName : "");
      setBankCode(data.content?.BankCode != null ? data.content?.BankCode : "");
      setSwift(data.content?.SWIFT != null ? data.content?.SWIFT : "");
      setBeneficiaryName(
        data.content?.BeneficiaryName != null
          ? data.content?.BeneficiaryName
          : ""
      );
      setCompantNameEng(
        data.content?.CompanyName_English != null
          ? data.content?.CompanyName_English
          : ""
      );
      setCompantNameChi(
        data.content?.CompanyName_Chinese != null
          ? data.content?.CompanyName_Chinese
          : ""
      );
      setPlaceofincorporation(
        data.content?.Placeofincorporation != null
          ? data.content?.Placeofincorporation
          : ""
      );
      setRegisteredAddress(
        data.content?.RegisteredAddress != null
          ? data.content?.RegisteredAddress
          : ""
      );
      setContactname(
        data.content?.Contactname != null ? data.content?.Contactname : ""
      );
      setContactemailaddress(
        data.content?.Contactemailaddress != null
          ? data.content?.Contactemailaddress
          : ""
      );
      setContactphonenumber(
        data.content?.Contactphonenumber != null
          ? data.content?.Contactphonenumber
          : ""
      );
      setBusinessRegistrationNumber(
        data.content?.BusinessRegistrationNumber != null
          ? data.content?.BusinessRegistrationNumber
          : ""
      );
      setErrorCodeCC(data.content?.status);
      setTriggerCCApi(true);

      return true;
    } catch (error) {
      console.error("Error uploading first file:", error);
      setStatus("Error uploading first file. Check console for details.");
      return false;
    }
  };

  const handleUploadTF = async () => {
    try {
      if (!file2) {
        console.error("Second file is missing!");
        setStatus("Please select the second file.");
        return;
      }
      const formData2 = new FormData();
      formData2.append("file", file2);

      console.log("Uploading second file...");
      const response = await fetch(`${BACKEND_URL}/uploadTFfile/`, {
        method: "POST",
        body: formData2,
        headers: { Accept: "application/json" },
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Server error: ${response.status} - ${errorText}`);
      }
      const data = await response.json();
      console.log("Second file uploaded successfully:", data);
      setContractType(
        data.content?.ContractType != null ? data.content?.ContractType : ""
      );
      setContractName(
        data.content?.ContractName != null ? data.content?.ContractName : ""
      );
      setSubcontractNo(
        data.content?.Sub_contractNo != null ? data.content?.Sub_contractNo : ""
      );

      setSubcontractno(
        data.content?.Sub_contractno != null ? data.content?.Sub_contractno : ""
      );

      setContractDetails(
        data?.content?.ContractDetails != null
          ? data?.content?.ContractDetails
          : ""
      );

      setProjectName(
        data.content?.ProjectName != null ? data.content?.ProjectName : ""
      );

      setProjectDetails(
        data.content?.ProjectDetails != null ? data.content?.ProjectDetails : ""
      );
      setDocumentCertifyingNo(
        data.content?.DocumentCertifyingNo != null
          ? data.content?.DocumentCertifyingNo
          : ""
      );
      setDocumentCertifyingIssuedby(
        data.content?.DocumentCertifyingIssuedby != null
          ? data.content?.DocumentCertifyingIssuedby
          : ""
      );
      setNameofDebtor(
        data.content?.NameofDebtor != null ? data.content?.NameofDebtor : ""
      );
      setRiverchainIDNo(
        data.content?.RiverchainIDNo != null ? data.content?.RiverchainIDNo : ""
      );

      setNameofPurchaserIfother(
        data.content?.NameofPurchaser_ifother != null
          ? data.content?.NameofPurchaser_ifother
          : ""
      );

      setNameofPurchaser(
        data.content?.NameofPurchaser != null
          ? data.content?.NameofPurchaser
          : ""
      );

      // DocumentOriginatingDebtNo
      setInvoiceNo(
        data.content?.DocumentOriginatingDebtNo != null
          ? data.content?.DocumentOriginatingDebtNo
          : ""
      );
      setDocumentCertifyingAmountHK(
        data.content?.DocumentCertifyingAmount_HK != null
          ? formatNumber(data.content?.DocumentCertifyingAmount_HK)
          : ""
      );

      setDocumentCertifyingDate(data.content?.DocumentCertifyingDate);

      // DocumentOriginatingDebtAmount_HK
      setInvoiceAmountHK(
        formatNumber(
          data.content?.DocumentOriginatingDebtAmount_HK != null &&
            data.content?.DocumentOriginatingDebtAmount_HK
        )
      );

      // DocumentOriginatingDebtDate
      setInvoiceDate(
        formatDate(
          data.content?.DocumentOriginatingDebtDate != null &&
            (data.content?.DocumentOriginatingDebtDate).split("T")[0]
        )
      );

      setDiscount_percentage_(
        (data.content?.FinalDiscount_percentage_ * 100).toFixed(2)
      );
      setRepaymentPercentage(
        (
          data.content
            ?.PrepaymentAmountasa_percentage_ofOriginalValueofReceivable * 100
        ).toFixed(2)
      );
      setPrepaymentAmount(
        formatNumber(
          data.content?.PrepaymentAmount != null &&
            data.content?.PrepaymentAmount
        )
      );
      setDocumentOriginatingtheDebt(
        data.content?.DocumentOriginatingtheDebt != null
          ? data.content?.DocumentOriginatingtheDebt
          : ""
      );
      setDocumentCertifyingthePaymentValuation(
        data.content?.DocumentCertifyingthePaymentValuation != null
          ? data.content?.DocumentCertifyingthePaymentValuation
          : ""
      );
      setSeller(data.content?.Seller != null ? data.content?.Seller : "");

      setRebateAmount(data.content?.RebateAmount && data.content?.RebateAmount);
      // setStatus("Successfully uploaded the data!");
      setTriggerSecondApi(true);
      setErrorCodeTF(data.content?.status);
      return true;
    } catch (error) {
      console.error("Error uploading second file:", error);
      setStatus("Upload failed, please check the uploaded file");
      setReload(true);
    }
  };

  const handleUpload = async () => {
    if (!file || !file2) {
      setStatus("Please select both files before uploading.");
      return;
    }
    setLoading(true);
    setStatus("Uploading first file...");

    if (errorCodeCC === "ERROR") {
      // setStatus("Somethig wrong with the Transaction File");
      setLoading(true);
      console.log("Loading:", loading);
      return;
    }

    if (errorCodeTF === "ERROR") {
      // setStatus("Somethig wrong with the Transaction File");
      setLoading(true);
      console.log("Loading:", loading);
      return;
    }

    const firstFileSuccess = await handleUploadCC();

    if (firstFileSuccess) {
      console.log("First upload successful, now uploading second file...");
      setStatus("Uploading second file...");
      setFinalUpload(true);
      await handleUploadTF();
    } else {
      console.log("First upload failed, skipping second upload.");
    }

    setLoading(false);
  };

  useEffect(() => {
    if (errorCodeCC === "ERROR") {
      setLoading(true);
      console.log("Loading:", loading);
      return;
    }

    if (errorCodeTF === "ERROR") {
      setLoading(true);
      console.log("Loading:", loading);
      return;
    }

    // compantNameEng
    if (errorCodeCC === "OK" && errorCodeTF === "OK") {
      const newPurchaserName =
        nameofPurchaser && nameofPurchaser === "Other LP"
          ? nameofPurchaserIfother
          : nameofPurchaser;

      const newProjectName = contractName === "" ? projectName : contractName;

      const newprojectDetails =
        contractDetails === "" ? projectDetails : contractDetails;

      const newSubcontractNo =
        subcontractno === "" ? subcontractNo : subcontractno;

      const newCertifyingDate =
        (documentCertifyingDate && documentCertifyingDate === "") ||
        documentCertifyingDate === undefined ||
        documentCertifyingDate === "n/a" ||
        documentCertifyingDate === "N/A" ||
        documentCertifyingDate === null
          ? ""
          : formatDate(
              documentCertifyingDate !== null &&
                documentCertifyingDate.split("T")[0]
            );

      const newRebateAmount =
        rebateAmount === 0 || rebateAmount == null
          ? "0.00"
          : formatNumber(rebateAmount);

      const xmlData = `<?xml version="1.0" encoding="UTF-8"?>
<isheet recordcount="string">
	<id>0</id>
	<title>string</title>
	<description>string</description>
	<status>string</status>
	<accesstype>string</accesstype>
	<type>string</type>
	<viewlink>string</viewlink>
	<allowsections>string</allowsections>
	<allowlookup>string</allowlookup>
	<displayisheet>string</displayisheet>
	<searchasdefaultview>string</searchasdefaultview>
	<enableversion>string</enableversion>
	<enablesheetalerter>string</enablesheetalerter>
	<alertercondition>string</alertercondition>
	<overrideitemmodifieddate>string</overrideitemmodifieddate>
	<enablebulkinsertupdate>string</enablebulkinsertupdate>
	<fielddescriptions>string</fielddescriptions>
	<enablerowlocking>string</enablerowlocking>
	<setcharlimittruncatemultilinetextenabled>string</setcharlimittruncatemultilinetextenabled>
	<setcharlimittruncatemultilinetextval>string</setcharlimittruncatemultilinetextval>
	<allowchoicelistvaluesforreuse>string</allowchoicelistvaluesforreuse>
	<allowscorelistvaluesforreuse>string</allowscorelistvaluesforreuse>
	<allowIsheetComments>string</allowIsheetComments>
	<shareRecordsLimit>0</shareRecordsLimit>
	<shareRecordsLimitEnabled>0</shareRecordsLimitEnabled>
	<enableIsheetAddRecordFormSharing>string</enableIsheetAddRecordFormSharing>
	<allowViewBaseRendering>string</allowViewBaseRendering>
	<columns>
		<column sequence="string" attributecolumnid="290">
			<columnid>0</columnid>
			<name>test</name>
			<type>0</type>
			<status>0</status>
			<systemgeneratedtype>string</systemgeneratedtype>
			<section>0</section>
			<description>string</description>
			<addtodefaultview>string</addtodefaultview>
			<columnconditionstate>string</columnconditionstate>
			<columnconditions>
				<row>
					<rowid>0</rowid>
					<columnid>0</columnid>
					<operatorid>0</operatorid>
					<oprand>string</oprand>
					<userlookupfilters>
						<userlookupfilter>
							<oprand>string</oprand>
							<userlookuptype>string</userlookuptype>
						</userlookupfilter>
					</userlookupfilters>
					<logicaltype>string</logicaltype>
					<sheetfiltervaluetypeid>string</sheetfiltervaluetypeid>
					<displaytype>string</displaytype>
					<scoreConditionTypeid>0</scoreConditionTypeid>
					<sourceColumnId>0</sourceColumnId>
				</row>
			</columnconditions>
			<columnspecificdetail>
				<defaultvalue>string</defaultvalue>
				<columnwidth>string</columnwidth>
				<sheetname>string</sheetname>
				<sitename>string</sitename>
				<mandatory>string</mandatory>
				<allowsearch>string</allowsearch>
				<maxchars>0</maxchars>
				<allowfieldfromanotherisheet>string</allowfieldfromanotherisheet>
				<allowrichhtmltext>string</allowrichhtmltext>
				<numberoflines>0</numberoflines>
				<displaymethod>string</displaymethod>
				<includeotheroption>string</includeotheroption>
				<singleormultileselectioninsearch>string</singleormultileselectioninsearch>
				<choices>
					<choice>
						<id>string</id>
						<label>string</label>
						<score>string</score>
						<color>string</color>
						<imageid>0</imageid>
					</choice>
				</choices>
				<includeinalertpreferences>string</includeinalertpreferences>
				<min>string</min>
				<max>string</max>
				<decimalplaces>0</decimalplaces>
				<showthousandseparators>string</showthousandseparators>
				<showaspercentage>string</showaspercentage>
				<symbolId>string</symbolId>
				<numberDecimalFormat>DOT_AS_DECIMAL/COMMA_AS_DECIMAL</numberDecimalFormat>
				<symbolPosition>before/after</symbolPosition>
				<formattype>string</formattype>
				<dateformat>string</dateformat>
				<defaultdateandtime>string</defaultdateandtime>
				<sheetlookup>string</sheetlookup>
				<fielddisplay>string</fielddisplay>
				<allowmultipleusers>string</allowmultipleusers>
				<methodtype>string</methodtype>
				<sheetids>string</sheetids>
				<allowuserstorenamelinks>string</allowuserstorenamelinks>
				<sheetid>0</sheetid>
				<columnids>string</columnids>
				<viewid>0</viewid>
				<allowmultiplevalues>string</allowmultiplevalues>
				<restrictdelete>string</restrictdelete>
				<displaycolumnnameprefix>string</displaycolumnnameprefix>
				<linkname>string</linkname>
				<donotcountweekendsonlycountmontofri>string</donotcountweekendsonlycountmontofri>
				<joinconditions>
					<joincondition>
						<currentsheetcolumnid>0</currentsheetcolumnid>
						<targetsheetcolumnid>0</targetsheetcolumnid>
					</joincondition>
				</joinconditions>
				<formula>string</formula>
				<startvalue>0</startvalue>
				<prefix>string</prefix>
				<postfix>string</postfix>
				<minlength>0</minlength>
				<lookupglossarysheetid>0</lookupglossarysheetid>
				<lookupglossarysheetviewid>0</lookupglossarysheetviewid>
				<width>0</width>
				<otherscorevalue>string</otherscorevalue>
				<importdatafromexternalsource>string</importdatafromexternalsource>
				<analysisengine>string</analysisengine>
				<attachmentcustomfolderid>0</attachmentcustomfolderid>
				<singleLineEmailValidation>string</singleLineEmailValidation>
				<readonly>string</readonly>
				<virtualColumn>0</virtualColumn>
				<externalSource>string</externalSource>
				<allowInlineEditing>string</allowInlineEditing>
			</columnspecificdetail>
			<rawdata>
				<value>string</value>
				<choices>
					<choice>
						<id>string</id>
						<label>string</label>
						<score>string</score>
						<color>string</color>
						<imageid>0</imageid>
					</choice>
				</choices>
				<date>string</date>
				<time>string</time>
				<linkdisplayname>string</linkdisplayname>
				<linkdisplayurl>string</linkdisplayurl>
				<lookups>
					<lookup>
						<id>string</id>
						<email>string</email>
						<userlookuptype>string</userlookuptype>
					</lookup>
				</lookups>
				<folders>
					<folder>
						<folderid>string</folderid>
					</folder>
				</folders>
				<documents>
					<document>
						<docid>string</docid>
					</document>
				</documents>
				<fromdate>string</fromdate>
				<todate>string</todate>
				<attachments>
					<attachment>
						<file>string</file>
						<name>string</name>
						<order>string</order>
						<id>0</id>
						<extension>string</extension>
						<parentfolderid>0</parentfolderid>
						<filehttplink>string</filehttplink>
						<folderpath>string</folderpath>
						<folderhttplink>string</folderhttplink>
						<filesize>0</filesize>
						<redactionstatus>true</redactionstatus>
						<siteid>0</siteid>
						<displayname>string</displayname>
					</attachment>
				</attachments>
				<isheetitems>
					<isheetitem>
						<recordid>string</recordid>
						<linkname>string</linkname>
						<apilink>string</apilink>
						<httplink>string</httplink>
					</isheetitem>
				</isheetitems>
				<daydifference>string</daydifference>
			</rawdata>
			<colViewPosition>0</colViewPosition>
			<columntype>string</columntype>
			<createdDate>2025-02-17T09:13:44.900Z</createdDate>
			<modifiedDate>2025-02-17T09:13:44.900Z</modifiedDate>
			<injectReferenceColumn>0</injectReferenceColumn>
			<parentColumnID>0</parentColumnID>
			<reusecolumnidfromisheet>0</reusecolumnidfromisheet>
			<choicelistid>0</choicelistid>
			<editpermission>0</editpermission>
			<templatesheetcolumnid>0</templatesheetcolumnid>
			<uploadpermission>0</uploadpermission>
			<deletepermission>0</deletepermission>
			<sourceSheetID>0</sourceSheetID>
		</column>
	</columns>
	<metadata>
		<siteName>string</siteName>
		<siteId>0</siteId>
		<sheetId>0</sheetId>
		<viewId>0</viewId>
		<viewName>string</viewName>
		<sheetName>string</sheetName>
	</metadata>
	    <head>
      <headcolumn sequence="5" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="326">
        <columnvalue><![CDATA[Riverchain ID]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="6" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="298">
        <columnvalue><![CDATA[Client Name English]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="7" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="299">
        <columnvalue><![CDATA[Client Name Chinese]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="8" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="534">
        <columnvalue><![CDATA[Purchaser Company Name]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="9" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="486">
        <columnvalue><![CDATA[Purchaser Signor Name]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="10" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="487">
        <columnvalue><![CDATA[Purchaser Signor Title]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="11" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="523">
        <columnvalue><![CDATA[Purchaser BR No. (Riverchain International)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="12" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="524">
        <columnvalue><![CDATA[Purchaser BR No. (AR Horizon)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="13" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="525">
        <columnvalue><![CDATA[Purchaser Prepayment Amount]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="14" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="526">
        <columnvalue><![CDATA[Purchaser Prepayment Percentage]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="15" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="527">
        <columnvalue><![CDATA[Purchaser discount percentage]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="16" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="301">
        <columnvalue><![CDATA[Client place of incorporation]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="17" columntypealias="SHEET_COLUMN_TYPE_MULTIPLE_LINE_TEXT" columntypeid="2" columnid="302">
        <columnvalue><![CDATA[Client Address]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="18" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="303">
        <columnvalue><![CDATA[Client Contact Name]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="19" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="305">
        <columnvalue><![CDATA[Client Contact Email]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="20" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="308">
        <columnvalue><![CDATA[Receivable subcontract No.]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="21" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="309">
        <columnvalue><![CDATA[Contract Type]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="22" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="310">
        <columnvalue><![CDATA[Project Name]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="23" columntypealias="SHEET_COLUMN_TYPE_MULTIPLE_LINE_TEXT" columntypeid="2" columnid="311">
        <columnvalue><![CDATA[Project Details]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="24" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="313">
        <columnvalue><![CDATA[Invoice No.]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="25" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="316">
        <columnvalue><![CDATA[Certificate No.]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="26" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="318">
        <columnvalue><![CDATA[Certificate Issue by]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="27" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="528">
        <columnvalue><![CDATA[Client BR No.]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="28" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="529">
        <columnvalue><![CDATA[Client Contact No.]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="29" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="552">
        <columnvalue><![CDATA[Riverchain Rebate]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="30" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="530">
        <columnvalue><![CDATA[Invoice Date]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="31" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="531">
        <columnvalue><![CDATA[Invoice amount]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="32" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="532">
        <columnvalue><![CDATA[Certificate Date]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="33" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="533">
        <columnvalue><![CDATA[Certificate Amount]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="34" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="535">
        <columnvalue><![CDATA[Receivable Type]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="35" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="536">
        <columnvalue><![CDATA[Receivable Certificate Type]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="36" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="547">
        <columnvalue><![CDATA[Seller Account No.]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="37" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="548">
        <columnvalue><![CDATA[Seller Bank Name]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="38" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="549">
        <columnvalue><![CDATA[Seller Bank Code]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="39" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="550">
        <columnvalue><![CDATA[Seller Bank Swift Code]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="40" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="551">
        <columnvalue><![CDATA[Seller Bank Account Name]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="41" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="323">
        <columnvalue><![CDATA[Debtor Name]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="42" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="660">
        <columnvalue><![CDATA[Purchaser BR No. (Riverchain One)]]></columnvalue>
      </headcolumn>
    </head>
	<data>
		<item externalid="" itemsequence="1" itemid="114">
			      <column sequence="5" attributecolumnid="326">
                <rawdata>
                    <value><![CDATA[${riverchainIDNo}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${riverchainIDNo}]]></value>
                </displaydata>
            </column>
            <column sequence="6" attributecolumnid="298">
                <rawdata>
                    <value><![CDATA[${compantNameEng}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${compantNameEng}]]></value>
                </displaydata>
            </column>
            <column sequence="7" attributecolumnid="299">
                <rawdata>
                    <value><![CDATA[${compantNameChi}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${compantNameChi}]]></value>
                </displaydata>
            </column>
            <column sequence="8" attributecolumnid="534">
                <rawdata>
                    <value><![CDATA[${newPurchaserName}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${newPurchaserName}]]></value>
                </displaydata>
            </column>
            <column sequence="9" attributecolumnid="486">
                <rawdata>
                    <value><![CDATA[Ben Wong]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[Ben Wong]]></value>
                </displaydata>
            </column>
            <column sequence="10" attributecolumnid="487">
                <rawdata>
                    <value><![CDATA[Director]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[Director]]></value>
                </displaydata>
            </column>
            <column sequence="11" attributecolumnid="523">
                <rawdata>
                    <value><![CDATA[74297558]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[74297558]]></value>
                </displaydata>
            </column>
            <column sequence="12" attributecolumnid="524">
                <rawdata>
                    <value><![CDATA[76796716]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[76796716]]></value>
                </displaydata>
            </column>
            <column sequence="13" attributecolumnid="525">
                <rawdata>
                    <value><![CDATA[${prepaymentAmount}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${prepaymentAmount}]]></value>
                </displaydata>
            </column>
            <column sequence="14" attributecolumnid="526">
                <rawdata>
                    <value><![CDATA[${repaymentPercentage}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${repaymentPercentage}]]></value>
                </displaydata>
            </column>
            <column sequence="15" attributecolumnid="527">
                <rawdata>
                    <value><![CDATA[${discount_percentage_}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${discount_percentage_}]]></value>
                </displaydata>
            </column>
            <column sequence="16" attributecolumnid="301">
                <rawdata>
                    <value><![CDATA[${placeofincorporation}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${placeofincorporation}]]></value>
                </displaydata>
            </column>
             <column sequence="17" attributecolumnid="302">
                <rawdata>
                    <value><![CDATA[${registeredAddress}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${registeredAddress}]]></value>
                </displaydata>
            </column>
            <column sequence="18" attributecolumnid="303">
                <rawdata>
                    <value><![CDATA[${contactname}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${contactname}]]></value>
                </displaydata>
            </column>
            <column sequence="19" attributecolumnid="305">
                <rawdata>
                    <value><![CDATA[${contactemailaddress}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${contactemailaddress}]]></value>
                </displaydata>
            </column>
            <column sequence="20" attributecolumnid="308">
                <rawdata>
                    <value><![CDATA[${newSubcontractNo}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${newSubcontractNo}]]></value>
                </displaydata>
            </column>
            <column sequence="21" attributecolumnid="309">
                <rawdata>
                    <value><![CDATA[${contractType}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${contractType}]]></value>
                </displaydata>
            </column>
            <column sequence="22" attributecolumnid="310">
                <rawdata>
                    <value><![CDATA[${newProjectName}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${newProjectName}]]></value>
                </displaydata>
            </column>
            <column sequence="23" attributecolumnid="311">
                <rawdata>
                    <value><![CDATA[${newprojectDetails}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${newprojectDetails}]]></value>
                </displaydata>
            </column>
            <column sequence="24" attributecolumnid="313">
                <rawdata>
                    <value><![CDATA[${invoiceNo}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${invoiceNo}]]></value>
                </displaydata>
            </column>
            <column sequence="25" attributecolumnid="316">
                <rawdata>
                    <value><![CDATA[${documentCertifyingNo}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${documentCertifyingNo}]]></value>
                </displaydata>
            </column>
            <column sequence="26" attributecolumnid="318">
                <rawdata>
                    <value><![CDATA[${documentCertifyingIssuedby}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${documentCertifyingIssuedby}]]></value>
                </displaydata>
            </column>
            <column sequence="27" attributecolumnid="528">
                <rawdata>
                    <value><![CDATA[${businessRegistrationNumber}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${businessRegistrationNumber}]]></value>
                </displaydata>
            </column>
            <column sequence="28" attributecolumnid="529">
                <rawdata>
                    <value><![CDATA[]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[]]></value>
                </displaydata>
            </column>
            <column sequence="29" attributecolumnid="552">
                <rawdata>
                    <value><![CDATA[${newRebateAmount}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${newRebateAmount}]]></value>
                </displaydata>
            </column>
            <column sequence="30" attributecolumnid="530">
                <rawdata>
                    <value><![CDATA[${invoiceDate}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${invoiceDate}]]></value>
                </displaydata>
            </column>
            <column sequence="31" attributecolumnid="531">
                <rawdata>
                    <value><![CDATA[${invoiceAmountHK}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${invoiceAmountHK}]]></value>
                </displaydata>
            </column>
            <column sequence="32" attributecolumnid="532">
                <rawdata>
                    <value><![CDATA[${newCertifyingDate}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${newCertifyingDate}]]></value>
                </displaydata>
            </column>
            <column sequence="33" attributecolumnid="533">
                <rawdata>
                    <value><![CDATA[${documentCertifyingAmountHK}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${documentCertifyingAmountHK}]]></value>
                </displaydata>
            </column>
            <column sequence="34" attributecolumnid="535">
                <rawdata>
                    <value><![CDATA[${documentOriginatingtheDebt}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${documentOriginatingtheDebt}]]></value>
                </displaydata>
            </column>
            <column sequence="35" attributecolumnid="536">
                <rawdata>
                    <value><![CDATA[${documentCertifyingthePaymentValuation}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${documentCertifyingthePaymentValuation}]]></value>
                </displaydata>
            </column>
            <column sequence="36" attributecolumnid="547">
                <rawdata>
                    <value><![CDATA[${bankAccountNumber}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${bankAccountNumber}]]></value>
                </displaydata>
            </column>
            <column sequence="37" attributecolumnid="548">
                <rawdata>
                    <value><![CDATA[${bankName}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${bankName}]]></value>
                </displaydata>
            </column>
             <column sequence="38" attributecolumnid="549">
                <rawdata>
                    <value><![CDATA[${bankCode}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${bankCode}]]></value>
                </displaydata>
            </column>
             <column sequence="39" attributecolumnid="550">
                <rawdata>
                    <value><![CDATA[${swift}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${swift}]]></value>
                </displaydata>
            </column>
             <column sequence="40" attributecolumnid="551">
                <rawdata>
                    <value><![CDATA[${beneficiaryName}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${beneficiaryName}]]></value>
                </displaydata>
            </column>
            <column sequence="41" attributecolumnid="323">
                <rawdata>
                    <value><![CDATA[${nameofDebtor}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${nameofDebtor}]]></value>
                </displaydata>
            </column>
             <column sequence="42" attributecolumnid="660">
                <rawdata>
                    <value><![CDATA[${riverchainIDNo}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${riverchainIDNo}]]></value>
                </displaydata>
            </column>
      </item>
	</data>
	<sheettypeid>0</sheettypeid>
	<enablesmartform>string</enablesmartform>
	<allowDeletedItemsView>string</allowDeletedItemsView>
	<allowAllColumnsInCustomView>string</allowAllColumnsInCustomView>
</isheet>`;

      const postData = async () => {
        try {
          const res = await axios.post(`${API_URL}/post`, xmlData, {
            headers: {
              "Content-Type": "application/xml",
            },
          });
          setStatus("iSheet successfully generated");

          console.log("XML_Data", xmlData);

          onUploadSuccess();
          setTimeout(() => {
            setStatus(null);
          }, 5000);
          removeFile();
          removeFile2();
        } catch (error) {
          console.error("Error sending data:", error);
        }
      };

      postData();
      setTriggerSecondApi(false); // Reset flag after API call
    }
  }, [finalUpload]);

  const handleFile1Change = (e) => {
    const selectedFile = e.target.files[0];
    console.log("selectedFile:", selectedFile);
    if (selectedFile) {
      setFile(selectedFile);
      setStatusCC(null);
    }
  };

  const isRemovingRef = useRef(false);
  const isRemovingRef2 = useRef(false);

  const removeFile = () => {
    isRemovingRef.current = true;
    setFile(null);
    setStatusCC(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
  };

  useEffect(() => {
    if (isRemovingRef.current) {
      isRemovingRef.current = false;
      return; // Skip status update when removing
    }

    if (file) {
      console.log("File:", file);
      handleUploadCC();
    }

    if (errorCodeCC === "ERROR") {
      setStatusCC("Upload failed validation error");
    } else if (errorCodeCC === "OK") {
      setStatusCC("");
    }
  }, [errorCodeCC, file]);

  const handleFile2Change = (e) => {
    const selectedFile2 = setFile2(e.target.files[0]);
    console.log("selectedFile2:", selectedFile2);
    if (selectedFile2) {
      setFile2(selectedFile2);
      setStatusTF(null);
    }
  };

  const removeFile2 = () => {
    isRemovingRef2.current = true;
    setFile2(null);
    setStatusTF(null);
    setLoading(false);
    if (fileInputRef2.current) {
      fileInputRef2.current.value = "";
    }
  };

  useEffect(() => {
    if (isRemovingRef2.current) {
      isRemovingRef2.current = false;
      return; // Skip status update when removing
    }

    if (file2) {
      console.log("File:", file2);
      handleUploadTF();
    }

    if (errorCodeTF === "ERROR") {
      setStatusTF("Upload failed validation error");
      setLoading(true);
    } else if (errorCodeTF === "OK") {
      setStatusTF("");
      setLoading(false);
    }
  }, [errorCodeTF, file2]);

  return (
    <>
      <h4
        style={{ textAlign: "center", marginBottom: "10px", marginTop: "30px" }}
      >
        Upload Client Card & Transaction File
      </h4>
      <hr />
      <div
        style={{
          backgroundColor: "#f3f3f3",
          padding: "20px",
          borderRadius: "10px",
          marginBottom: "10px",
        }}
      >
        <label style={{ fontWeight: "bold" }}>
          Upload Client Card (CC) <span className="text-danger">*</span>
        </label>
        <br />
        <input type="file" onChange={handleFile1Change} ref={fileInputRef} />
      </div>

      {file && (
        <div
          style={{
            border: "1px solid #ccc",
            borderRadius: "8px",
            padding: "10px",
            marginTop: "10px",
            marginBottom: "20px",
            position: "relative",
          }}
        >
          <div>
            <p style={{ margin: "5px 0", fontWeight: "bold" }}>{file.name}</p>
            <p style={{ margin: "5px 0", color: "#555" }}>
              {(file.size / 1024).toFixed(2)} KB
            </p>
          </div>
          <button
            onClick={removeFile}
            style={{
              position: "absolute",
              top: "12px",
              right: "12px",
              backgroundColor: "#f44336",
              color: "#fff",
              border: "none",
              borderRadius: "50%",
              width: "30px",
              height: "30px",
              cursor: "pointer",
            }}
          >
            &times;
          </button>
        </div>
      )}

      {statusCC && (
        <p
          style={{
            color: statusCC.includes("error")
              ? "#f44336"
              : statusCC.includes("successfully")
              ? "green"
              : "grey",
            marginTop: "-20px",
            textAlign: "center",
          }}
        >
          {statusCC}
        </p>
      )}

      <div
        style={{
          backgroundColor: "#f3f3f3",
          padding: "20px",
          borderRadius: "10px",
        }}
      >
        <label style={{ fontWeight: "bold" }}>
          Upload Transaction File (TF) <span className="text-danger">*</span>
        </label>
        <br />
        <input type="file" onChange={handleFile2Change} ref={fileInputRef2} />
      </div>

      {file2 && (
        <div
          style={{
            border: "1px solid #ccc",
            borderRadius: "8px",
            padding: "10px",
            marginTop: "10px",
            position: "relative",
          }}
        >
          <div>
            <p style={{ margin: "5px 0", fontWeight: "bold" }}>{file2.name}</p>
            <p style={{ margin: "5px 0", color: "#555" }}>
              {(file2.size / 1024).toFixed(2)} KB
            </p>
          </div>
          <button
            onClick={removeFile2}
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              backgroundColor: "#f44336",
              color: "#fff",
              border: "none",
              borderRadius: "50%",
              width: "30px",
              height: "30px",
              cursor: "pointer",
            }}
          >
            &times;
          </button>
        </div>
      )}

      {statusTF && (
        <p
          style={{
            color: statusTF.includes("error")
              ? "#f44336"
              : statusTF.includes("successfully")
              ? "green"
              : "grey",
            marginTop: "5px",
            textAlign: "center",
          }}
        >
          {statusTF}
        </p>
      )}

      <button
        onClick={handleUpload}
        disabled={loading}
        className="btn btn-primary"
        style={{ marginTop: "30px" }}
      >
        {loading
          ? "Generating isheet"
          : loading === "error"
          ? "something wrong with the files"
          : "Generate iSheet"}
      </button>
      {status && (
        <p
          style={{
            backgroundColor: status.includes("error")
              ? "#7b1103"
              : status.includes("successfully")
              ? "green"
              : "grey",
            borderRadius: "10px",
            marginTop: "10px",
            padding: "10px",
            color: "#fff",
          }}
        >
          {status}
        </p>
      )}
    </>
  );
};

export default FileUpload;
